import { render, staticRenderFns } from "./support_zoom.vue?vue&type=template&id=74ec01c2&"
import script from "./support_zoom.vue?vue&type=script&lang=js&"
export * from "./support_zoom.vue?vue&type=script&lang=js&"
import style0 from "./support_zoom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports